import { AxiosError } from 'axios';
import { getNotificationStyle } from '../common/notification';
import { IFilter } from '../model/CommonModel';
import AjexPortalService from "./api";
import config from './config';

const commonURL: string | undefined = process.env.REACT_APP_TMS_COMMON_SERVICE;

const trackingHistory = config.get('trackingHistory');
const filter = config.get('filter');
const detail = config.get('detail');
const audit = config.get('audit');
const temperaturedevice = config.get('tempraturedevice');
const tempwaybill = config.get('tempwaybill');
const templatest = config.get('templatest');
const pieceLevel = config.get('pieceLevel');
const tempImei = config.get('tempImei');
const pieceBarcode = config.get('pieceBarcode');


const manifestAudit = config.get('manifestAudit');
export const GetTrackingHistoryService = async (filteredData: IFilter) => {
    try {
        return await AjexPortalService.post(`${commonURL}${trackingHistory}/${filter}`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const GetTrackingHistoryByWayBillService = async (wayBill: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${trackingHistory}/${wayBill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

//https://apps-sit.aj-ex.com/tms-common-service/api/v1/tracking-history/detail/A1010003273
export const GetHistoryDetailByWayBillService = async (wayBill: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${trackingHistory}/${detail}/${wayBill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
//https://apps-sit.aj-ex.com/tms-common-service/api/v1/tracking-history/piece-level/A1010002883
export const GetPieceLevelTrackingDetailByWayBillService = async (wayBill: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${trackingHistory}/${pieceLevel}/${wayBill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const GetPieceLevelTrackingDetailService = async (pieceNumber: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${trackingHistory}/${pieceBarcode}/${pieceNumber}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}


// export const GetAuditByWayBillService = async (wayBill: string) => {
//     try {
//         return await AjexPortalService.get(`${commonURL}${manifestAudit}/${audit}/${wayBill}`);
//     } catch (error: unknown) {
//         const err = error as AxiosError;
//         getNotificationStyle(err?.response);
//         return err?.response;
//     }
// }
//{{commons}}/api/v1/manifest-audit/audit/change/A1010001957
export const GetAuditByWayBillService = async (wayBill: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${manifestAudit}/${audit}/change/${wayBill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const SearchTrackingFilterService = async (filteredData: Partial<IFilter>) => {
    try {
        return await AjexPortalService.post(`${commonURL}${trackingHistory}/${filter}`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
}

export const GetTemperatureByWayBillService = async (wayBill: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${temperaturedevice}/${tempwaybill}/${wayBill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const GetRealtimeTemperature = async () => {
    try {
        return await AjexPortalService.get(`${commonURL}${temperaturedevice}/${templatest}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const GetTemperatureHistoryByImeiService = async (imei: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${temperaturedevice}/${tempImei}/${imei}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}